import { FeedbackRptService } from '../services';
import { FeedbackRptConstants } from '../constants';
import {alertActions} from '.';

export const FeedbackRptActions = {
    getAll,
    ServiceReq,
    loadingData,
    exportData,
    exportServiceReq,
    ClosureRequest,
    RejectionRequest,
    getServiceAgentList
};

function getAll(obj)
{
    return dispatch =>{
        dispatch(request());
        FeedbackRptService.fetchFeedbackData(obj).then(response => {
            dispatch(loadingData(false));
            dispatch(success(response.ResponseData))

            var data = response.ResponseData;
            if (data != null) {
                data.forEach(function (v) { delete v.TotalRows });
            }
            dispatch(successExport(data))
        },
        error => {
            dispatch(failure(error.toString()));
            dispatch(alertActions.error(error.toString()));
        }
        
        );
    };
    function request() { return { type : FeedbackRptConstants.GETALL_REQUEST } }
    function success(datas) { return { type: FeedbackRptConstants.GETALL_SUCCESS, datas } }
    function successExport(datas) { return { type: FeedbackRptConstants.GETEXPORT_SUCCESS, datas } }
    function failure(error) { return { type: FeedbackRptConstants.GETALL_FAILURE, error } }
}
function getServiceAgentList()
{
    return dispatch =>{
        dispatch(request());
        FeedbackRptService.fetchGetServiceAgentList().then(response => {
            dispatch(loadingData(false));
            dispatch(success(response.ResponseData))

             console.log("Service Agent API Response:", response.ResponseData);
        },
        error => {
            dispatch(failure(error.toString()));
            dispatch(alertActions.error(error.toString()));
        }
        
        );
    };
    function request() { return { type : FeedbackRptConstants.GETSERVICEAGENTLIST_REQUEST } }
    function success(data) { return { type: FeedbackRptConstants.GETSERVICEAGENTLIST_SUCCESS, data } }
    function failure(error) { return { type: FeedbackRptConstants.GETSERVICEAGENTLIST_FAILURE, error } }
}
function ClosureRequest(data) {
    return dispatch => {
        return FeedbackRptService.ClosureRequest(data).then(
            response => {
                if (response && response.ResponseCode) {
                    if (response.ResponseCode === "200") {
                        dispatch(success(response.ResponseData))
                        dispatch(alertActions.success(response.ResponseMessage));
                    } else if (response.ResponseCode === "400") {
                        dispatch(alertActions.warning(response.ResponseMessage))
                    } else {
                        dispatch(alertActions.error(response.ResponseMessage))
                    }
                }
                return response;
            },
            error => {
                dispatch(alertActions.error(error.toString()));
                throw error;
            }
        );
    };

    function request(data) { return { type: FeedbackRptConstants.CLOSURE_REQUEST, data } }
    function success(data) { return { type: FeedbackRptConstants.CLOSURE_SUCCESS, data } }
    function failure(error) { return { type: FeedbackRptConstants.CLOSURE_FAILURE, error } }
};

function RejectionRequest(data) {
    return dispatch => {
        return FeedbackRptService.RejectionRequest(data).then(
            response => {
                if (response && response.ResponseCode) {
                    if (response.ResponseCode === "200") {
                        dispatch(success(response.ResponseData))
                        dispatch(alertActions.success(response.ResponseMessage));
                    } else if (response.ResponseCode === "400") {
                        dispatch(alertActions.warning(response.ResponseMessage))
                    } else {
                        dispatch(alertActions.error(response.ResponseMessage))
                    }
                }
                return response;
            },
            error => {
                dispatch(alertActions.error(error.toString()));
                throw error;
            }
        );
    };

    function request(data) { return { type: FeedbackRptConstants.REJECTION_REQUEST, data } }
    function success(data) { return { type: FeedbackRptConstants.REJECTION_SUCCESS, data } }
    function failure(error) { return { type: FeedbackRptConstants.REJECTION_FAILURE, error } }
};

function ServiceReq(obj)
{
    return dispatch =>{
        dispatch(request());
        FeedbackRptService.ServiceReqData(obj).then(response => {
            dispatch(loadingData(false));
            dispatch(success(response.ResponseData))

            var data = response.ResponseData;
            if (data != null) {
                data.forEach(function (v) { delete v.TotalRows });
            }
            dispatch(successExport(data))
        },
        error => {
            dispatch(failure(error.toString()));
            dispatch(alertActions.error(error.toString()));
        }
        
        );
    };
    function request() { return { type : FeedbackRptConstants.ServiceReq_REQUEST } }
    function success(datas) { return { type: FeedbackRptConstants.ServiceReq_SUCCESS, datas } }
    function successExport(datas) { return { type: FeedbackRptConstants.GETEXPORT_SUCCESS, datas } }
    function failure(error) { return { type: FeedbackRptConstants.ServiceReq_FAILURE, error } }
}

function exportData(obj) {
    return dispatch => {
        dispatch(request());
        FeedbackRptService.fetchFeedbackData(obj).then(response => {
            dispatch(loadingData(false));
            var data = response.ResponseData;
            if (data != null) {
                data.forEach(function (v) { delete v.TotalRows });
            }
            dispatch(success(data))
        },
            error => {
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
            });
    };
    function request() { return { type: FeedbackRptConstants.GETEXPORT_REQUEST } }
    function success(datas) { return { type: FeedbackRptConstants.GETEXPORT_SUCCESS, datas } }
    function failure(error) { return { type: FeedbackRptConstants.GETEXPORT_FAILURE, error } }
}

function exportServiceReq(obj) {
    return dispatch => {
        dispatch(request());
        return FeedbackRptService.ServiceReqData(obj).then(response => {
            if (response && response.ResponseCode && response.ResponseCode !== "200") {
                dispatch(failure(response.ResponseMessage || "Export failed"));
                dispatch(alertActions.error(response.ResponseMessage || "Export failed"));
                throw new Error(response.ResponseMessage || "Export failed");
            }
            dispatch(loadingData(false));
            var data = response.ResponseData;
            if (data != null) {
                data.forEach(function (v) { delete v.TotalRows });
            }
            dispatch(success(data));
            return response;
        },
            error => {
                dispatch(failure(error.toString()));
                dispatch(alertActions.error(error.toString()));
                throw error;
            });
    };
    function request() { return { type: FeedbackRptConstants.GETEXPORT_REQUEST } }
    function success(datas) { return { type: FeedbackRptConstants.GETEXPORT_SUCCESS, datas } }
    function failure(error) { return { type: FeedbackRptConstants.GETEXPORT_FAILURE, error } }
}

function loadingData(isbool) {
    return {
        type: FeedbackRptConstants.LOADING_REQUEST, isbool
    }
}
